import { jsx, jsxs } from "react/jsx-runtime";
import { Checkbox, Label, cn } from "@pcln/horizon";
import { Discount } from "pcln-icons";
const HotelOption = {
    id: 'addHotel',
    name: 'addHotel',
    label: 'Add a hotel',
    value: 'STAY',
    type: 'STAY'
};
const FlightOption = {
    id: 'addFlights',
    name: 'addFlights',
    label: 'Add a flight',
    value: 'FLY',
    type: 'FLY'
};
const CarOption = {
    id: 'addCar',
    name: 'addCar',
    label: 'Add a car',
    value: 'DRIVE',
    type: 'DRIVE'
};
const productConfigs = {
    hotels: {
        defaultOptions: [
            FlightOption,
            CarOption
        ],
        defaultLabel: 'Bundle + Save'
    },
    flights: {
        defaultOptions: [
            HotelOption,
            CarOption
        ],
        defaultLabel: 'Bundle + Save'
    },
    cars: {
        defaultOptions: [
            HotelOption,
            FlightOption
        ],
        defaultLabel: 'Bundle + Save'
    }
};
function BundleAndSave({ productType, options, checkedValues, onSelectionChange, label, className = '', tripType, removeBackground = false }) {
    const config = productConfigs[productType];
    const defaultOptions = options || config.defaultOptions;
    const defaultLabel = label || config.defaultLabel;
    const containerClassName = cn('flex flex-row gap-4 rounded-lg px-2 py-3', !removeBackground && 'md:bg-highlight-3', className);
    function getUpdatedTripType(checked, option) {
        return checked ? `${tripType}:${option.type}` : tripType.replace(`:${option.type}`, '');
    }
    return /*#__PURE__*/ jsxs("div", {
        className: containerClassName,
        role: "group",
        "aria-label": defaultLabel,
        children: [
            /*#__PURE__*/ jsxs("div", {
                className: "flex shrink-0 items-center gap-1.5 pl-2",
                children: [
                    /*#__PURE__*/ jsx(Discount, {
                        size: 24,
                        color: "success"
                    }),
                    /*#__PURE__*/ jsx("span", {
                        className: "text-success-dark text-body3 whitespace-nowrap font-medium",
                        children: defaultLabel
                    })
                ]
            }),
            /*#__PURE__*/ jsx("div", {
                className: "flex flex-row flex-wrap gap-x-4 gap-y-1",
                children: defaultOptions.map((option)=>{
                    const checked = checkedValues[option.value] || false;
                    return /*#__PURE__*/ jsxs(Label, {
                        htmlFor: option.id,
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ jsx(Checkbox, {
                                size: "16",
                                id: option.id,
                                value: option.value,
                                name: option.name,
                                checked: checked,
                                handleChange: ()=>{
                                    const newCheckedState = !checked;
                                    const updatedTripType = getUpdatedTripType(newCheckedState, option);
                                    onSelectionChange(updatedTripType, newCheckedState, option.value);
                                }
                            }),
                            /*#__PURE__*/ jsx("span", {
                                className: "ml-2 text-body3 whitespace-nowrap",
                                children: option.label
                            })
                        ]
                    }, option.id);
                })
            })
        ]
    });
}
export { BundleAndSave, HotelOption };
